"use client"

import type { ComponentProps } from 'react'
import { SafeImage } from '@/components/ui/safe-image'
import { FilterBrandTile } from '@/components/filters/filter-brand-tile'

type SafeImageProps = ComponentProps<typeof SafeImage>

interface FilterCardImageProps extends Omit<SafeImageProps, 'fallbackContent'> {
  /** Compact tuple because every filter card serializes these values into Flight. */
  tile: readonly [
    brand: string | null | undefined,
    logo: string | null | undefined,
    code?: string | null,
    size?: 'xs' | 'sm' | 'md',
  ]
}

/**
 * Keeps the filter-specific fallback inside one client boundary. Passing the
 * complete tile as a ReactNode from every server-rendered card duplicates that
 * tree in the RSC response; scalar fallback data is enough to reconstruct it.
 */
export function FilterCardImage({
  tile,
  ...imageProps
}: FilterCardImageProps) {
  return (
    <SafeImage
      {...imageProps}
      fallbackContent={
        <FilterBrandTile
          brand={tile[0]}
          logo={tile[1]}
          code={tile[2]}
          size={tile[3]}
        />
      }
    />
  )
}
